var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0195 11.9439C24.0299 14.3169 23.3358 16.6398 22.025 18.6187C20.7141 20.5976 18.8453 22.1437 16.6549 23.0614C14.4645 23.9792 12.0509 24.2274 9.71927 23.7747C7.38768 23.3219 5.24282 22.1886 3.55594 20.518C1.86906 18.8473 0.715923 16.7144 0.242347 14.389C-0.231228 12.0636 -0.00396777 9.65012 0.895389 7.45375C1.79474 5.25738 3.3258 3.37679 5.29495 2.04979C7.26409 0.722794 9.58288 0.00898996 11.9581 -0.00135077C15.143 -0.0152166 18.2029 1.23548 20.4649 3.47563C22.7268 5.71578 24.0054 8.76188 24.0195 11.9439Z",
    fill: "#C8DDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.998 4L11.8906 4.36462V14.9441L11.998 15.0512L16.9087 12.1484L11.998 4Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9988 4L7.08789 12.1484L11.9988 15.0512V9.91619V4Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.998 15.9794L11.9375 16.0532V19.8218L11.998 19.9984L16.9118 13.0781L11.998 15.9794Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9988 19.9984V15.9794L7.08789 13.0781L11.9988 19.9984Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.998 15.0529L16.9088 12.1501L11.998 9.91797V15.0529Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08789 12.1501L11.9988 15.0529V9.91797L7.08789 12.1501Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.482b72ba6e3bc80aeffd7249b9ef8469.svg";
export { ForwardRef as ReactComponent };